
	// 导入vue ,watch ，以及Component组件
	import {
		Vue,
		Component,
		Prop,
		PropSync,
		Watch,
		Inject,
	} from "vue-property-decorator";
	// 组件（可能是头尾部组件）
	import Marquee from "@/components/semantics/Marquee.vue";
	import SortHeader from "@/components/base/table/header/SortHeader.vue";
	import Pagination from "@components/base/pagination/PcmPagination.vue";

	export default {
		name: "PolicyGuidelines",
		data() {
			return {
				showData: {}
			}
		},
		computed: {

		},

		created() {
			this.showData = this.$route.query;
			console.log(this.showData);
		},
		mounted() {


		},
		methods: {

		},
	};
